var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall"},_vm._l((_vm.mallList),function(item,index){return _c('div',{key:index,staticClass:"mall_li",on:{"click":_vm.notOpen}},[_c('img',{staticClass:"li_img",attrs:{"src":item.img}}),_c('span',{staticClass:"good"},[_vm._v("Good Swap")]),_c('span',[_vm._v(_vm._s(_vm.$t(item.text)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }